/**
 * @module app.shared
 */

export {};

function stringTrimEndPolyfill(value: string) {
    const trimmed = value.trim();
    const index = value.indexOf(trimmed);
    return value.slice(index, value.length);
}

String.prototype.trimEnd = String.prototype.trimEnd || stringTrimEndPolyfill;
